import StaticAdModel from "../models/static.ad.model";
import { StaticAdType } from "../types/staticAd"
import { useReducerAsState } from "./useReducerAsState"

interface State {
    loading : boolean;
    error: string;
    staticAd : StaticAdType | null;
}

const useStaticAds = () => {
    const [state, setState] = useReducerAsState<State>({
        loading: false,
        error: "",
        staticAd: null
    })

    const { staticAd, loading } = state

    const findStaticAd = async (itemId: number) => {
        setState({error:"", loading: true})
        const response = await StaticAdModel.find(itemId);
        if(response.error){
            setState({error: response.error, loading: false, staticAd: null})
            return
        }

        setState({error: "", loading: false, staticAd: response.staticAd?.data[0]})
    }

    const saveStaticAd = async (item : StaticAdType): Promise<boolean> => {
        setState({error:"", loading: true})
        const response = await StaticAdModel.save(item);
        if(response.error){
            setState({error: response.error, loading: false})
            return false
        }

        setState({error: "", loading: false})
        return true
    }

    return {
        staticAd,
        loading,
        findStaticAd,
        saveStaticAd
    }
}

export default useStaticAds